import * as React from 'react'
import EditGroupListItem from '../../../modals/groups/edit/EditGroupListItem'
import { faUserCheckSolid, faUserDashedRegular } from '@/lib/fa'
import GroupsLIstNavbar from '../components/GroupsLIstNavbar'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const EditGroupsDefaultList = ({ setSelectedGroup }) => {
  const { t } = useLocalize()
  const defatultGroups = [
    { id: -1, name: t('driverModule.active-drivers'), icon: faUserCheckSolid, active: true },
    { id: -2, name: t('driverModule.inactive-drivers'), icon: faUserDashedRegular, active: false },
  ]
  return (
    <div>
      <GroupsLIstNavbar title={t('driverModule.default')} />
      <div className="tw-flex tw-flex-col">
        {defatultGroups.map((group) => (
          <EditGroupListItem
            key={group.id}
            group={group}
            icon={group.icon}
            setSelectedGroup={setSelectedGroup}
          />
        ))}
      </div>
    </div>
  )
}

export default EditGroupsDefaultList
